import { componentProvider } from 'js-component-framework';
import ModalSignup from './modal-signup';
import './modal-signup.scss';

/*
 * This component is imported in the child theme for the Classroom Questions
 * fauxwall. Rather than removing outright, consider moving to the child theme.
 */
const modalSignupConfig = {
  component: ModalSignup,
  name: 'modal-signup',
  querySelector: {
    form: '.login-form',
  },
};

componentProvider(modalSignupConfig);
